import * as React from "react";

/** Bottom nav vocabulary icon (grid/list outline) */
export const IconNavVocabulary = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_nav_vocab)">
      <path
        d="M4.5498 4.5H23.4121C23.4273 4.50726 23.4491 4.51991 23.4697 4.53906C23.4857 4.55393 23.4948 4.56715 23.5 4.5752V23.3721C23.4966 23.3773 23.4931 23.3841 23.4883 23.3906C23.4758 23.4074 23.461 23.4257 23.4434 23.4434C23.4257 23.461 23.4074 23.4758 23.3906 23.4883C23.3841 23.4931 23.3773 23.4966 23.3721 23.5H4.57617C4.56818 23.495 4.55437 23.4862 4.53906 23.4697C4.51991 23.4491 4.50726 23.4273 4.5 23.4121V4.5498C4.50002 4.53856 4.50208 4.5317 4.50391 4.52734C4.50601 4.52235 4.50948 4.51786 4.51367 4.51367C4.51786 4.50948 4.52235 4.50601 4.52734 4.50391C4.5317 4.50208 4.53856 4.50002 4.5498 4.5ZM4.83301 23.167H23.167V4.83301H4.83301V23.167ZM18.833 18.5V18.833H13.833V18.5H18.833ZM9.5 18.5V18.833H9.16699V18.5H9.5ZM18.833 13.833V14.167H13.833V13.833H18.833ZM9.5 13.833V14.167H9.16699V13.833H9.5ZM18.833 9.16699V9.5H13.833V9.16699H18.833ZM9.5 9.16699V9.5H9.16699V9.16699H9.5Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_nav_vocab">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
